<template>
  <div class="promopanel">
    <CommonHead></CommonHead>
    <b-modal
      id="cart_notificaion"
      ref="cartmodal"
      :title="this.cartOrderMsg"
      title-tag="h3"
      ok-only
      modal-class="common_pop cart_notificaion"
    ></b-modal>
    <div class="container">
      <div class="promopage">
        <a @click="togglepromo" class="ordershow" href="javascript:;"
          >Summary<b-img
            class="plusfil"
            src="/shop/images/add.svg"
            alt="add"
          ></b-img
          ><b-img
            class="minusfil"
            src="/shop/images/minus.svg"
            alt="minus"
          ></b-img
        ></a>
        <div class="leftpromo">
          <h1>Summary</h1>
          <div class="promodata">
            <transition name="slide-fade">
              <div
                v-show="currentStep >= 1 && selectedFabricTypeName.length"
                class="commondata-div firstset"
              >
                <h3>Fabric Type:</h3>
                <p>{{ selectedFabricTypeName }}</p>
              </div>
            </transition>
            <transition name="slide-fade">
              <div
                v-show="currentStep >= 2 && selectedFabricNameValue.length"
                class="commondata-div secondset"
              >
                <h3>Fabric Name:</h3>
                <p>
                  {{ selectedFabricNameValue }} /
                  {{
                    selectedFabricColorName.length
                      ? selectedFabricColorName
                      : "No Color Selected"
                  }}
                </p>
                <transition name="slide-fade">
                  <b-img
                    class="selectedimg"
                    v-show="currentStep >= 2 && selectedFabricColorImg.length"
                    :src="selectedFabricColorImg || ''"
                    fluid
                    alt="image"
                  ></b-img>
                </transition>
              </div>
            </transition>
            <transition name="slide-fade">
              <div
                v-show="currentStep >= 4 && showDimension"
                class="commondata-div"
              >
                <h3>Dimensions:</h3>
                <p>
                  <span>Rod Inches:</span><span>{{ dRodValue }}"</span>
                </p>
                <p>
                  <span>Left Return:</span><span>{{ leftReturnValue }}"</span>
                </p>
                <p>
                  <span>Right Return:</span><span>{{ rightReturnValue }}"</span>
                </p>
              </div>
            </transition>
            <transition name="slide-fade">
              <div
                v-show="currentStep >= 4 && styleSelectedDone"
                class="commondata-div"
              >
                <h3>Top Styles</h3>
                <p>
                  <span>Style:</span><span> {{ selectedStyleName }}</span>
                </p>
                <p v-show="styleOptionVisiblity.pocket">
                  <span>Pocket Size:</span
                  ><span> {{ styleOptionNames.pocket }}</span>
                </p>
                <p v-show="styleOptionVisiblity.header">
                  <span>Header Size:</span
                  ><span> {{ styleOptionNames.header }}</span>
                </p>
                <p v-show="styleOptionVisiblity.grommet">
                  <span>Color & Size:</span
                  ><span>{{ styleOptionNames.grommet }}</span>
                </p>
                <p v-show="styleOptionVisiblity.pin">
                  <span>Pin Setting:</span
                  ><span> {{ styleOptionNames.pin }}</span>
                </p>
                <p v-show="styleOptionVisiblity.beadedWeight">
                  <span>Beaded Weight:</span
                  ><span> {{ styleOptionNames.beadedWeight }}</span>
                </p>
                <p v-show="styleOptionVisiblity.bottomHeader">
                  <span>Bottom Heading:</span>
                  <span>{{ styleOptionNames.bottomHeader }}</span
                  >
                </p>
                <p v-show="styleOptionVisiblity.bottomPocket">
                  <span>Bottom Rod Pocket:</span
                  ><span> {{ styleOptionNames.bottomPocket }}</span>
                </p>
              </div>
            </transition>
            <transition name="slide-fade">
              <div
                v-show="currentStep >= 4 && showDimension"
                class="commondata-div"
              >
                <h3>Panels & Pairs:</h3>
                <p>
                  <span>Pair/Panel:</span><span>{{ panelpairQtySheer }}</span>
                </p>
                <p>
                  <span>Overlap Inches:</span><span>{{ overlapSheer }}"</span>
                </p>
                <p>
                  <span>Fullness:</span><span>{{ dFullnessValue }}"</span>
                </p>
                <p>
                  <span>Finished Length:</span
                  ><span>{{ finishedLength }}"</span>
                </p>
              </div>
            </transition>
            <transition name="slide-fade">
              <div
                v-show="
                  currentStep >= 4 &&
                  styleSelectedDone &&
                  selectedFabricType != 'Sheer'
                "
                class="commondata-div"
              >
                <h3>Panels & Pairs:</h3>
                <p>
                  <span>Panels / Pairs Qty:</span
                  ><span> {{ panelpairQtyName }}</span>
                </p>
              </div>
            </transition>
            <transition name="slide-fade">
              <div
                v-show="currentStep >= 4 && styleSelectedDone && !showDimension"
                class="commondata-div"
              >
                <h3>Measurements:</h3>
                <p>
                  <span>Left Return:</span><span>{{ leftReturnValue }}"</span>
                </p>
                <p>
                  <span>Right Return:</span><span>{{ rightReturnValue }}"</span>
                </p>
                <p>
                  <span>Overlap:</span><span>{{ overlapValue }}"</span>
                </p>
                <p>
                  <span>Finished Length:</span
                  ><span>{{ finishedLength }}"</span>
                </p>
              </div>
            </transition>
            <transition name="slide-fade">
              <div
                v-show="
                  currentStep >= 4 &&
                  this.selectedFabricType != 'LightControlled'
                "
                class="commondata-div"
              >
                <h3>Lining</h3>
                <p>
                  <span>Lining:</span
                  ><span> {{ liningselectMap[liningselect] }}</span>
                </p>
                <p v-show="blackoutguard">
                  <span>BlackoutGuard&trade;:</span
                  ><span> {{ (blackoutguard == true) ? "Yes" : "No" }}</span>
                </p>
                <!-- <p v-show="selectedFabricType != 'Sheer'">
                  <span>Interlining:</span
                  ><span> {{ interliningselectMap[interliningselect] }}</span>
                </p> -->
              </div>
            </transition>
            <transition name="slide-fade">
              <div
                v-show="currentStep >= 4 && styleSelectedDone && !showDimension"
                class="commondata-div"
              >
                <h3>Trimming:</h3>
                <p>
                  <span>Trimming Type:</span
                  ><span> {{ trimmingType }}</span>
                </p>
                <p v-if="trimmingType != 'No Trim'">
                  <span>Trimming Pattern:</span
                  ><span> {{ trimmingPatternName }}</span>
                </p>
                <p v-if="trimmingType != 'No Trim'">
                  <span>Trimming Color:</span
                  ><span> {{ selectedTrimColorName }}</span>
                </p>
              </div>
            </transition>
            <transition name="slide-fade">
              <div
                v-show="currentStep >= 4 && styleSelectedDone && !showDimension"
                class="commondata-div"
              >
                <p>
                 <span>Project Name:</span
                  ><span> {{ line }}</span>
                </p>
              </div>
            </transition>
            <transition name="slide-fade">
              <div
                v-show="currentStep >= 4 && styleSelectedDone && !showDimension"
                class="commondata-div"
              >
                <p>
                  <span>Notes:</span
                  ><span> {{ customernotes }}</span>
                </p>
              </div>
            </transition>
            <transition name="slide-fade">
              <div
                v-show="currentStep >= 4 && styleSelectedDone && !showDimension"
                class="commondata-div"
              >
                <h3 class="font-weight-bold">Suggested Retail Charges:</h3>
                <p>
                  <span>Base Price:</span>
                  <span>${{ basePrice }}</span>
                </p>
                <p>
                  <span>Lining Surcharge:</span>
                  <span>${{ interliningSurcharge }}</span>
                </p>
                <p v-show="blackoutguardCost > 0">
                  <span>BlackoutGuard&trade; Surcharge:</span>
                  <span>${{ blackoutguardCost }}</span>
                </p>
                <p>
                  <span>Trim Surcharge::</span>
                  <span>${{ trimSurcharge }}</span>
                </p>
                <p>
                  <span>Trim Cost:</span>
                  <span>${{ trimCost }}</span>
                </p>
              </div>
            </transition>
            <transition name="slide-fade">
              <div
                v-show="currentStep >= 4 && styleSelectedDone"
                class="commondata-div lastpricediv"
              >
                <p class="font-weight-bold text-left">
                  <span>Suggested Retail (ea):</span><span>${{ (rawDiscountedAmount * 2).toFixed(2) }}</span>
                </p>
                <p class="font-weight-bold text-left">
                  <span>Wholesale (ea):</span><span> {{ calculationValue }}</span>
                </p>
              </div>
            </transition>
            <div
              v-show="currentStep >= 4 && styleSelectedDone"
              class="quantity-div"
            >
              <span>Qty:</span>
              <div class="samediv quantity">
                <div class="qtydiv">
                  <span @click="decrement">-</span>

                  <input
                    type="number"
                    :value="qty"
                    @change="onChangeQTY"
                    @blur="onChangeQTY"
                    step="1"
                  />

                  <span @click="increment" class="lastspan">+</span>
                </div>
              </div>
            </div>
            <h3 v-show="currentStep >= 4 && styleSelectedDone">
              Subtotal:<span>${{ (qty * rawCalculation).toFixed(2) }}</span>
            </h3>
            <div class="promo-btns">
              <b-button
                type="submit"
                class="AddTOCartBtn"
                :disabled="!canSave || !styleSelectedDone"
                variant="dark"
                @click="addtocartpanel">
                {{ this.$route.query.hasOwnProperty('cart') ? "Update Cart" : "Add to cart"}}
              </b-button>
              <b-button
                :disabled="!canSave || !styleSelectedDone"
                @click="saveToProject"
                variant="outline-primary"
              >
                <b-img
                  class="saveproject"
                  src="/shop/images/bookmark.svg"
                  fluid
                  alt="save image"
                ></b-img>
                <b-img
                  class="saveproject white"
                  src="/shop/images/bookmark-white.svg"
                  fluid
                  alt="save image"
                ></b-img
                >{{
                  this.$route.params.id
                    ? "Update Project Item"
                    : "Save to Projects"
                }}
              </b-button>
              <b-button
                :disabled="!canSave"
                @click="printQuote"
                class="printQuoteModelBtn"
                variant="outline-primary"
              >Print Quote</b-button>
            </div>
          </div>
        </div>
        <div class="rightpromo">
          <h1>Panel Program</h1>
          <b-form class="commonform">
            <div class="availabledata">
              <ul class="avail_data">
                <li>
                  <a href="javascript:;"
                    ><span>Fabric Type</span>
                    <v-select
                      :options="fabrictype"
                      label="text"
                      :clearable="false"
                      :searchable="false"
                      @input="loadNames"
                      v-model="fabrictype_value"
                      placeholder="Please Select Fabric Type"
                    ></v-select>
                  </a>
                </li>
                <li v-bind:class="{ 'not-available': currentStep < 2 }">
                  <a
                    href="javascript:;"
                    @click="toggleColors"
                    v-bind:class="{ collapsed: !colorCollapsed }"
                    ><span>Fabric Name</span>
                    <v-select
                      :options="fabricname"
                      label="text"
                      :clearable="false"
                      :searchable="false"
                      @input="loadColors"
                      v-model="selectedFabricName"
                      placeholder="Please Select Fabric Name"
                    ></v-select>
                    <md-progress-spinner
                      v-show="loadingName || loadingColor"
                      style="stroke: #aaa; margin-left: auto"
                      :md-stroke="3"
                      :md-diameter="24"
                      md-mode="indeterminate" />
                    <b-img
                      class="addicon"
                      src="/shop/images/add.svg"
                      fluid
                      alt="add image"
                    ></b-img
                    ><b-img
                      class="minusicon"
                      src="/shop/images/minus.svg"
                      fluid
                      alt="minus image"
                    ></b-img
                  ></a>
                  <b-collapse id="fabric-name" v-model="colorCollapsed">
                    <h3>Select Color</h3>
                    <div class="select-color">
                      <a
                        href="javascript:;"
                        v-for="color in fabriccolors"
                        :key="color['INVENTCOLORID']"
                        @click="selectColor(color)"
                        v-bind:class="{
                          'image-name-box': true,
                          selected:
                            color['INVENTCOLORID'] === selectedFabricColor,
                        }"
                      >
                        <div class="image-box">
                          <b-img
                            class="colorimg"
                            :src="color['IMAGE']"
                            fluid
                            alt="image"
                          ></b-img>
                        </div>
                        <h4>{{ color["COLORNAME"] }}</h4>
                        <h6 class="text-left">{{ color["STATUS"] }}</h6>
                        <h6 class="text-left">{{color["QTYONHAND"]}} {{ color['STATUS'] == 'Active' ? 'yards in stock' : 'yards remaining' }}</h6>
                      </a>
                    </div>
                  </b-collapse>
                </li>
                <li v-bind:class="{ 'not-available': currentStep < 4 }" v-show="showDimension">
                  <a href="javascript:;" v-b-toggle.dimension
                    >Dimensions<b-img
                      class="addicon"
                      src="/shop/images/add.svg"
                      fluid
                      alt="add image"
                    ></b-img
                    ><b-img
                      class="minusicon"
                      src="/shop/images/minus.svg"
                      fluid
                      alt="minus image"
                    ></b-img
                  ></a>
                  <b-collapse id="dimension">
                    <div class="measurement-div no-bottom-border">
                      <div class="length-div">
                        <span>Rod Inches:</span>
                        <md-field>
                          <md-input
                            type="number"
                            @input="calculateFW"
                            v-model="dRodValue"
                            name="rodInches"
                          ></md-input>
                        </md-field>
                      </div>
                    </div>
                    <div class="measurement-div no-bottom-border">
                      <div class="length-div">
                        <span>Left Return:</span>
                        <md-field>
                          <md-input
                            type="number"
                            @input="calculateFW"
                            v-model="leftReturnValue"
                            name="left-inches"
                          ></md-input>
                        </md-field>
                      </div>
                      <div class="length-div">
                        <span>Right Return:</span>
                        <md-field>
                          <md-input
                            type="number"
                            @input="calculateFW"
                            v-model="rightReturnValue"
                            name="right-inches"
                          ></md-input>
                        </md-field>
                      </div>
                    </div>
                    <h3 class="regularfont">Select Pair/Panel:</h3>
                    <div class="select-radio">
                      <md-radio
                        @change="calculateFW"
                        v-model="panelpairQtySheer"
                        name="dPair"
                        value="PAIR"
                        class="md-radio-override"
                      >
                        <p>Pair</p></md-radio
                      >
                      <md-radio
                        @change="calculateFW"
                        v-model="panelpairQtySheer"
                        name="dPanel"
                        value="PANEL"
                        class="md-radio-override"
                      >
                        <p>Panel</p></md-radio
                      >
                    </div>
                    <h3 class="regularfont" v-if="panelpairQtySheer == 'PAIR'">
                      Overlap Inches:
                    </h3>
                    <div
                      class="select-radio"
                      v-if="panelpairQtySheer == 'PAIR'"
                    >
                      <md-radio
                        @change="calculateFW"
                        v-model="overlapSheer"
                        name="dONone"
                        value="0"
                        class="md-radio-override"
                      >
                        <p>None</p></md-radio
                      >
                      <md-radio
                        @change="calculateFW"
                        v-model="overlapSheer"
                        name="dO1"
                        value="1"
                        class="md-radio-override"
                      >
                        <p>1"</p></md-radio
                      >
                      <md-radio
                        @change="calculateFW"
                        v-model="overlapSheer"
                        name="dO1"
                        value="2"
                        class="md-radio-override"
                      >
                        <p>2"</p></md-radio
                      >
                      <md-radio
                        @change="calculateFW"
                        v-model="overlapSheer"
                        name="dO1"
                        value="3"
                        class="md-radio-override"
                      >
                        <p>3"</p></md-radio
                      >
                      <md-radio
                        @change="calculateFW"
                        v-model="overlapSheer"
                        name="dO1"
                        value="4"
                        class="md-radio-override"
                      >
                        <p>4"</p></md-radio
                      >
                    </div>
                    <div class="measurement-div no-bottom-border">
                      <div class="length-div">
                        <span>Fullness:</span>
                        <md-field>
                          <md-input
                            @input="calculateFW"
                            type="number"
                            v-model="dFullnessValue"
                            :disabled="true"
                            name="dFullness"
                          ></md-input>
                        </md-field>
                      </div>
                      <div class="length-div">
                        <span>Finished Length:</span>
                        <md-field>
                          <input
                            type="number"
                            min="1"
                             max="99"
                            step=".01"
                            @blur="onSheerFinishedLengthChange"
                            @input="onSheerFinishedLengthChange"
                            v-model="finishedLength"
                            name="finished-length"
                          />
                        </md-field>
                        <p class="validmsg" v-show="FLZ > 0">Please specify a finished length that is an increment of .125".</p>
                      </div>
                    </div>
                    <h3>Finished Width : {{ finishedWidth }}"</h3>
                  </b-collapse>
                </li>
                <li v-bind:class="{ 'not-available': currentStep < 4 }">
                  <a href="javascript:;" v-b-toggle.top-style
                    >Top Styles<b-img
                      class="addicon"
                      src="/shop/images/add.svg"
                      fluid
                      alt="add image"
                    ></b-img
                    ><b-img
                      class="minusicon"
                      src="/shop/images/minus.svg"
                      fluid
                      alt="minus image"
                    ></b-img
                  ></a>
                  <b-collapse id="top-style">
                    <h3 class="regularfont">Select Style:</h3>
                    <div class="select-radio">
                      <md-radio
                        v-for="style in styles"
                        :key="style.id"
                        v-model="selectedStyle"
                        @change="onStyleSelect"
                        :name="style.id"
                        :value="style.id"
                        ><b-img
                          class="lining-img"
                          :src="style.image"
                          fluid
                          alt="rm-sateen-white image"
                        ></b-img>
                        <p>{{ style.name }}</p></md-radio
                      >
                    </div>
                    <h3
                      v-show="styleOptionVisiblity.pocket"
                      class="regularfont"
                    >
                      Pocket Size:
                    </h3>
                    <div
                      v-show="styleOptionVisiblity.pocket"
                      class="select-radio"
                    >
                      <md-radio
                        @change="remapNamesToStyle"
                        v-for="pocket in staticOptions.pocket"
                        :key="pocket.PinSetDesc"
                        v-model="styleOptionValues.pocket"
                        :name="pocket.Description"
                        :value="pocket.Value"
                        class="md-radio-override"
                      >
                        <p>{{ pocket.Description }}</p></md-radio
                      >
                    </div>
                    <h3
                      v-show="styleOptionVisiblity.header"
                      class="regularfont"
                    >
                      Header Size:
                    </h3>
                    <div
                      v-show="styleOptionVisiblity.header"
                      class="select-radio"
                    >
                      <md-radio
                        @change="remapNamesToStyle"
                        v-for="header in staticOptions.header"
                        :key="header.Description"
                        v-model="styleOptionValues.header"
                        :name="header.Description"
                        :value="header.Value"
                        class="md-radio-override"
                      >
                        <p>{{ header.Description }}</p></md-radio
                      >
                    </div>
                    <h3
                      v-show="styleOptionVisiblity.grommet"
                      class="regularfont"
                    >
                      Grommet Color
                    </h3>
                    <div
                      v-show="styleOptionVisiblity.grommet"
                      class="select-radio"
                    >
                      <md-radio
                        @change="onGrommetColorChange"
                        v-for="(grommet, index) in grommetByColor.colors"
                        :key="index"
                        v-model="selectedGrommetColor"
                        :name="grommet"
                        :value="grommet"
                        ><b-img
                          class="lining-img"
                          :src="grommetByColor.sizes[grommet][0].image"
                          fluid
                          alt="rm-sateen-white image"
                        ></b-img>
                        <p>{{ grommet }}</p></md-radio
                      >
                    </div>
                    <div
                      v-show="styleOptionVisiblity.grommet"
                      class="gromet-color"
                    >
                      <span class="flex-column align-items-start">Select Grommet Size <span style="color:#f00">(Inside diameter)</span></span>
                      <v-select
                        @input="onGrommetSizeChange"
                        :options="
                          selectedGrommetColor == null
                            ? []
                            : grommetByColor.sizesIds[selectedGrommetColor]
                        "
                        label="name"
                        :clearable="false"
                        :searchable="false"
                        v-model="selectedGrommetSize"
                        placeholder="Please Select Gromet Size"
                      ></v-select>
                    </div>
                    <h3 v-show="styleOptionVisiblity.pin" class="regularfont">
                      Pin Setting:
                    </h3>
                    <div v-show="styleOptionVisiblity.pin" class="select-radio">
                      <md-radio
                        @change="remapNamesToStyle"
                        v-for="pin in staticOptions.pin"
                        :key="pin.PinSetDesc"
                        v-model="styleOptionValues.pin"
                        :name="pin.PinSetDesc"
                        :value="pin.PinSetSize"
                        class="md-radio-override"
                      >
                        <p>{{ pin.PinSetDiscFull }}</p></md-radio
                      >
                    </div>
                    <h3
                      v-show="styleOptionVisiblity.beadedWeight"
                      class="regularfont"
                    >
                      Beaded Weight:
                    </h3>
                    <div
                      v-show="styleOptionVisiblity.beadedWeight"
                      class="select-radio"
                    >
                      <md-radio
                        @change="remapNamesToStyle"
                        v-model="styleOptionValues.beadedWeight"
                        name="beadedWY"
                        value="0"
                        class="md-radio-override"
                      >
                        <p>NO</p></md-radio
                      >
                      <md-radio
                        @change="remapNamesToStyle"
                        v-model="styleOptionValues.beadedWeight"
                        name="beadedNY"
                        value="1"
                        class="md-radio-override"
                      >
                        <p>YES</p></md-radio
                      >
                    </div>
                    <h3
                      v-show="
                        styleOptionValues.beadedWeight == '0' &&
                        selectedFabricType == 'Sheer' && selectedStyleName == 'Shirred'
                      "
                      class="regularfont"
                    >
                      Bottom Heading:
                    </h3>
                    <div
                      v-show="
                        styleOptionValues.beadedWeight == '0' &&
                        selectedFabricType == 'Sheer' && selectedStyleName == 'Shirred'
                      "
                      class="select-radio"
                    >
                      <md-radio
                        @change="remapNamesToStyle"
                        v-for="bottomHeader in staticOptions.bottomHeader"
                        :key="bottomHeader.Description"
                        v-model="styleOptionValues.bottomHeader"
                        :name="bottomHeader.Description"
                        :value="bottomHeader.Value"
                        class="md-radio-override"
                      >
                        <p>{{ bottomHeader.Description }}</p></md-radio
                      >
                    </div>
                    <h3
                      v-show="
                        styleOptionValues.beadedWeight == '0' &&
                        selectedFabricType == 'Sheer' && selectedStyleName == 'Shirred'
                      "
                      class="regularfont"
                    >
                      Bottom Rod Pocket:
                    </h3>
                    <div
                      v-show="
                        styleOptionValues.beadedWeight == '0' &&
                        selectedFabricType == 'Sheer' && selectedStyleName == 'Shirred'
                      "
                      class="select-radio"
                    >
                      <md-radio
                        @change="remapNamesToStyle"
                        v-for="bottomPocket in staticOptions.bottomPocket"
                        :key="bottomPocket.Description"
                        v-model="styleOptionValues.bottomPocket"
                        :name="bottomPocket.Description"
                        :value="bottomPocket.Value"
                        class="md-radio-override"
                      >
                        <p>{{ bottomPocket.Description }}</p></md-radio
                      >
                    </div>
                  </b-collapse>
                </li>
                <li
                  v-bind:class="{ 'not-available': currentStep < 5 }"
                  v-show="!showDimension"
                >
                  <a href="javascript:;" v-b-toggle.panel-qty
                    >Panels/ Pairs Qty<b-img
                      class="addicon"
                      src="/shop/images/add.svg"
                      fluid
                      alt="add image"
                    ></b-img
                    ><b-img
                      class="minusicon"
                      src="/shop/images/minus.svg"
                      fluid
                      alt="minus image"
                    ></b-img
                  ></a>
                  <b-collapse id="panel-qty">
                    <div class="select-radio">
                      <md-radio
                        v-for="quantity in quantities"
                        :key="quantity['Description']"
                        @change="onPanelPairSelect"
                        v-model="panelpairQty"
                        :name="quantity['Description']"
                        :value="quantity['Widths']"
                        v-bind:class="{
                          'md-radio-override': !quantity['image'],
                        }"
                      >
                        <b-img
                          class="qty-img"
                          v-if="quantity.image"
                          :src="'/shop/attachments/promo/' + quantity.image"
                          fluid
                          alt="rm-sateen-white image"
                        ></b-img>
                        <p>{{ quantity.Description }}</p></md-radio
                      >
                    </div>
                  </b-collapse>
                </li>
                <li
                  v-bind:class="{ 'not-available': currentStep < 5 }"
                  v-show="!showDimension"
                >
                  <a href="javascript:;" v-b-toggle.measurements
                    >Measurements<b-img
                      class="addicon"
                      src="/shop/images/add.svg"
                      fluid
                      alt="add image"
                    ></b-img
                    ><b-img
                      class="minusicon"
                      src="/shop/images/minus.svg"
                      fluid
                      alt="minus image"
                    ></b-img
                  ></a>
                  <b-collapse id="measurements">
                    <div class="measurement-div">
                      <div class="length-div">
                        <span>Left Return: </span>
                        <md-field>
                          <md-input
                            type="number"
                            v-model="leftReturnValue"
                            name="left-return"
                          ></md-input>
                        </md-field>
                      </div>
                      <div class="length-div">
                        <span>Overlap: </span>
                        <md-field>
                          <md-input
                            type="number"
                            @input="calculateFW"
                            v-model="overlapValue"
                            :disabled="disableOverlapInput"
                            name="overlap"
                          ></md-input>
                        </md-field>
                      </div>
                      <div class="length-div">
                        <span>Finished Length: </span>
                        <md-field>
                          <input
                            type="number"
                            @blur="onFinishedLengthChange"
                            @input="onFinishedLengthChange"
                            v-model="finishedLength"
                            name="finished-length"
                          />
                        </md-field>
                        <p class="validmsg" v-show="FLZ > 0">Please specify a finished length that is an increment of .125".</p>
                      </div>
                      <div class="length-div">
                        <span>Right Return: </span>
                        <md-field>
                          <md-input
                            type="number"
                            v-model="rightReturnValue"
                            name="right-return"
                          ></md-input>
                        </md-field>
                      </div>
                    </div>
                  </b-collapse>
                </li>
                <li v-bind:class="{ 'not-available': currentStep < 5 }">
                  <a href="javascript:;" v-b-toggle.lining-type
                    >Type of Lining<b-img
                      class="addicon"
                      src="/shop/images/add.svg"
                      fluid
                      alt="add image"
                    ></b-img
                    ><b-img
                      class="minusicon"
                      src="/shop/images/minus.svg"
                      fluid
                      alt="minus image"
                    ></b-img
                  ></a>
                  <b-collapse id="lining-type">
                    <h3 class="regularfont">Select Lining type:</h3>
                    <div class="select-radio">
                      <md-radio
                        v-model="liningselect"
                        name="rm-white"
                        value="Unlined"
                        v-if="selectedFabricType == 'Sheer'"
                        class="md-radio-override"
                      >
                        <p>Unlined</p></md-radio
                      >
                      <md-radio
                        v-model="liningselect"
                        name="rm-white"
                        value="N1"
                        v-if="selectedFabricType != 'Sheer' && selectedFabricType == 'LightControlled'"
                        ><b-img
                          class="lining-img"
                          src="/shop/images/rm-sateen-white.jpg"
                          fluid
                          alt="No Lining image"
                        ></b-img>
                        <p>No Lining</p></md-radio
                      >
                      <md-radio
                        v-model="liningselect"
                        name="rm-white"
                        value="RDSSW"
                        v-if="selectedFabricType != 'Sheer'"
                        ><b-img
                          class="lining-img"
                          src="/shop/attachments/promo/RM Designer Super Sateen__White.png"
                          fluid
                          alt="rm-sateen-white image"
                        ></b-img>
                        <p>RM Designer Super Sateen - White</p></md-radio
                      >
                      <md-radio
                        v-model="liningselect"
                        name="rm-ivory"
                        value="RDSSI"
                        v-if="selectedFabricType != 'Sheer'"
                        ><b-img
                          class="lining-img"
                          src="/shop/attachments/promo/RM Designer Thremafoam__Pale Ivory.png"
                          fluid
                          alt="rm-sateen-white image"
                        ></b-img>
                        <p>RM Designer Super Sateen - Ivory</p></md-radio
                      >
                      <md-radio
                        v-model="liningselect"
                        name="ivory-inter-black"
                        value="RDLTI"
                        v-if="selectedFabricType != 'Sheer' && selectedFabricType != 'LightControlled'"
                        ><b-img
                          class="lining-img"
                          src="/shop/attachments/promo/RM_Designer_Lite-Tech_Non_FR_Blackout__Ivory.png"
                          fluid
                          alt="rm-sateen-white image"
                        ></b-img>
                        <p>RM Designer Lite-Tech Non FR Blackout - Ivory</p></md-radio
                      >
                      <md-radio
                        v-model="liningselect"
                        name="white-inter-black"
                        value="RDLTW"
                        v-if="selectedFabricType != 'Sheer' && selectedFabricType != 'LightControlled'"
                        ><b-img
                          class="lining-img"
                          src="/shop/attachments/promo/RM_Designer_Lite-Tech_Non_FR_Blackout__White.png"
                          fluid
                          alt="rm-sateen-white image"
                        ></b-img>
                        <p>RM Designer Lite-Tech Non FR Blackout - White</p></md-radio
                      >
                    </div>
                    <div class="trim-pattern" v-if="['RDLTW', 'RDLTI'].includes(liningselect) && ['Pleated Three Prong', 'Pleated Two Prong','Three Prong Tacked at Top','Two Prong Tacked at Top'].includes(selectedStyleName)">
                      <span>BlackoutGuard&trade;</span>
                      <v-select
                        :options="optinterlining"
                        label="text"
                        :reduce="(optinterlining) => optinterlining.value"
                        :clearable="false"
                        :searchable="false"
                        v-model="blackoutguard"
                        placeholder="Please Select RM Designer Interlining"
                      ></v-select>
                    </div>
                    <p v-if="['RDLTW', 'RDLTI'].includes(liningselect) && ['Pleated Three Prong', 'Pleated Two Prong','Three Prong Tacked at Top','Two Prong Tacked at Top'].includes(selectedStyleName)" class="validmsg font-weight-bold" style="margin-top:10px;"><em>**BlackoutGuard&trade; is highly recommended for blackout lined drapery with lighter color face fabric. <a href="/wp-content/uploads/2026/09/BlackoutGuard-Sell-Sheet.pdf" target="_blank">View More Information</a></em></p>
                  </b-collapse>
                </li>
                <li v-bind:class="{ 'not-available': currentStep < 5 }" v-show="!showDimension">
                <a href="javascript:;" v-b-toggle.trimming
                    >Trimming<b-img
                      class="addicon"
                      src="/shop/images/add.svg"
                      fluid
                      alt="add image"
                    ></b-img
                    ><b-img
                      class="minusicon"
                      src="/shop/images/minus.svg"
                      fluid
                      alt="minus image"
                    ></b-img
                  ></a>
                  <b-collapse id="trimming">
                    <h3 class="regularfont">Select Trimming:</h3>
                    <div class="select-radio">
                      <md-radio
                        v-model="trimmingType"
                        name="rm-white"
                        value="No Trim"
                        ><b-img
                          class="lining-img"
                          src="/shop/images/no-trim.png"
                          fluid
                          alt="No Lining image"
                        ></b-img>
                        <p>No Trim</p>
                      </md-radio>
                      <md-radio
                        v-model="trimmingType"
                        name="rm-white"
                        value="Trim on Left Edge"
                        v-if="panelpairQty == 1 || panelpairQty == 2"
                        ><b-img
                          class="lining-img"
                          src="/shop/images/trim-on-left.png"
                          fluid
                          alt="No Lining image"
                        ></b-img>
                        <p>Trim on Left Edge</p>
                      </md-radio>
                      <md-radio
                        v-model="trimmingType"
                        name="rm-white"
                        value="Trim on Right Edge"
                        v-if="panelpairQty == 1 || panelpairQty == 2"
                        ><b-img
                          class="lining-img"
                          src="/shop/images/trim-on-right.png"
                          fluid
                          alt="No Lining image"
                        ></b-img>
                        <p>Trim on Right Edge</p>
                      </md-radio>
                      <md-radio
                        v-model="trimmingType"
                        name="rm-white"
                        value="Trim on Both sides"
                        v-if="panelpairQty == 1 || panelpairQty == 2"
                        ><b-img
                          class="lining-img"
                          src="/shop/images/trim-on-both.png"
                          fluid
                          alt="No Lining image"
                        ></b-img>
                        <p>Trim on Both Sides</p>
                      </md-radio>
                      <md-radio
                        v-model="trimmingType"
                        name="rm-white"
                        value="Trim on Leading Edges"
                        v-if="panelpairQty == 3 || panelpairQty == 4"
                        ><b-img
                          class="lining-img"
                          src="/shop/images/trim-leading-edges.png"
                          fluid
                          alt="No Lining image"
                        ></b-img>
                        <p>Trim on Leading Edges</p>
                      </md-radio>
                      <md-radio
                        v-model="trimmingType"
                        name="rm-white"
                        value="Trim on all sides"
                        v-if="panelpairQty == 3 || panelpairQty == 4"
                        ><b-img
                          class="lining-img"
                          src="/shop/images/trim-on-all-sides.png"
                          fluid
                          alt="No Lining image"
                        ></b-img>
                        <p>Trim on all sides</p>
                      </md-radio>
                    </div>
                    <div
                      v-show="trimmingType != 'No Trim'"
                      class="trim-pattern"
                    >
                      <span>Select Trim Pattern</span>
                      <v-select
                        id="trim_pattern"
                        :options="trim_pattern"
                        label="ITEMNAME"
                        :reduce="trim_pattern => trim_pattern.ITEMID"
                        @input="loadTrimColors"
                        v-model="trimmingPattern"
                        placeholder="Please Select Fabric Pattern"
                      ></v-select>
                    </div>
                    <div class="select-color" v-show="trimmingType != 'No Trim' && trimmingPattern">
                      <a
                        href="javascript:;"
                        v-for="tcolor in trimcolors"
                        :key="tcolor['INVENTCOLORID']"
                        @click="selectTrimColor(tcolor)"
                        v-bind:class="{
                          'image-name-box': true,
                          selected:
                            tcolor['COLORNAME'] === selectedTrimColorName,
                        }"
                      >
                        <div class="image-box">
                          <b-img
                            class="colorimg"
                            :src="tcolor['IMAGE']"
                            fluid
                            alt="image"
                          ></b-img>
                        </div>
                        <h4>{{ tcolor["COLORNAME"] }}</h4>
                      </a>
                    </div>
                  </b-collapse>
                </li>
                <li v-bind:class="{ 'not-available': currentStep < 5 }">
                  <a href="javascript:;" v-b-toggle.line
                    >Project Name<b-img
                      class="addicon"
                      src="/shop/images/add.svg"
                      fluid
                      alt="add image"
                    ></b-img
                    ><b-img
                      class="minusicon"
                      src="/shop/images/minus.svg"
                      fluid
                      alt="minus image"
                    ></b-img
                  ></a>
                  <b-collapse id="line">
                    <div class="measurement-div">
                      <div class="length-div linediv">
                        <md-field :md-counter="false">
                          <md-input
                            type="text"
                            v-model="line"
                            maxlength="50"
                            name="lineno"
                          ></md-input>
                        </md-field>
                      </div>
                    </div>
                  </b-collapse>
                </li>
                <li v-bind:class="{ 'not-available': currentStep < 5 }">
                  <a href="javascript:;" v-b-toggle.customernotes
                    >Notes<b-img
                      class="addicon"
                      src="/shop/images/add.svg"
                      fluid
                      alt="add image"
                    ></b-img
                    ><b-img
                      class="minusicon"
                      src="/shop/images/minus.svg"
                      fluid
                      alt="minus image"
                    ></b-img
                  ></a>
                  <b-collapse id="customernotes">
                    <div class="measurement-div">
                      <div class="length-div linediv">
                        <md-field>
                          <md-input
                            type="text"
                            v-model="customernotes"
                            name="customernotes"
                          ></md-input>
                        </md-field>
                      </div>
                    </div>
                  </b-collapse>
                </li>
              </ul>
            </div>
          </b-form>
        </div>
      </div>
    </div>
    <CommonFoot></CommonFoot>
    <ProjectModal ref="project" />
    <b-modal
      id="printquote"
      ref="printquotemodal"
      title="Price to Display on Quote"
      title-tag="h3"
      ok-only
      modal-class="common_pop printquote"
    >
    <div class="radio-options">
      <md-field>
      <ul>
        <li><md-radio v-model="printquotetype" value="wholesale">Wholesale</md-radio></li>
        <li><md-radio v-model="printquotetype" value="markup"><div><md-input v-model="pqmarkupnum" type="number"></md-input><span class="md-suffix">% markup</span></div></md-radio></li>
      </ul>
      </md-field>
      <a @click="printQuoteGen" class="btn btn-dark btn-block">Print</a>
    </div>
    </b-modal>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import CommonHead from "@/components/CommonHead";
import CommonFoot from "@/components/CommonFoot";
import ProjectModal from "@/views/ProjectModal/ProjectModal.vue";
import Select2 from './Select2.vue';
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

export default {
  components: {
    CommonHead,
    CommonFoot,
    ProjectModal,
    Select2,
    "v-select": vSelect,
  },
  computed: {
    ...mapGetters(["user"]),
  },
  mounted() {
    console.log(this.$refs);
    if (this.$route.params.id) {
      this.loadData(this.$route.params.id);
    } else {
      this.init();
    }
    console.log(this.$route.params.id, "params");
    // this.$refs.project.show();
  },
  updated: function () {
    this.$nextTick(function () {
      this.doCalculation();
    });
  },
  data() {
    return {
      qty: 1,
      fabrictype_value: null,
      liningselectMap: {
        N1: "No Lining",
        RDSSW: "RM Designer Super Sateen - White",
        RDSSI: "RM Designer Super Sateen - Ivory",
        // RDOI: "RM Designer Outblack - Ivory",
        // RDOW: "RM Designer Outblack - White",
        RDLTI: "RM Designer Lite-Tech Non FR Blackout - Ivory",
        RDLTW: "RM Designer Lite-Tech Non FR Blackout - White",
        Unlined: "Unlined",
      },
      interliningselectMap: {
        No: "None",
        RDIW: "RM Designer Interlining - White",
        RDIN: "RM Designer Interlining - Natural",
      },
      disableOverlapInput: false,
      colorCollapsed: false,
      currentStep: 0,
      interliningselect: "No",
      liningselect: "RDSSW",
      fabrictype: [],
      selectedFabricType: null,
      selectedFabricTypeName: "",
      fabricname: [],
      selectedFabricName: "",
      selectedFabricNameValue: "",
      fabriccolors: [],
      selectedFabricColor: null,
      selectedFabricColorName: "",
      selectedFabricColorImg: "",
      grometcolor: [
        { value: "blue", text: "blue" },
        { value: "black", text: "black" },
        { value: "red", text: "red" },
        { value: "green", text: "green" },
      ],
      quantities: [],
      selectedQuantity: null,
      styles: [],
      selectedStyle: null,
      selectedStyleName: "",
      staticOptions: {
        pin: [],
        header: [],
        bottomPocket: [],
        pocket: [],
        grommet: [],
        bottomHeader: [],
      },
      styleOptionVisiblity: {
        grommet: false,
        pin: false,
        pocket: false,
        header: false,
        beadedWeight: false,
        LBeadedWeight: false,
        bottomHeader: false,
        bottomPocket: false,
      },
      styleOptionValues: {
        grommet: null,
        pin: null,
        pocket: null,
        header: null,
        beadedWeight: "0",
        LBeadedWeight: null,
        bottomHeader: null,
        bottomPocket: null,
      },
      styleOptionNames: {
        grommet: "",
        pin: "",
        pocket: "",
        header: "",
        beadedWeight: "No",
        LBeadedWeight: "",
        bottomHeader: "",
        bottomPocket: "",
      },
      blackoutguard: false,
      blackoutguardCost: 0,
      optinterlining:[
        { value: false, text: "No"},
        { value: true, text: "Yes"},
      ],
      styleSelectedDone: false,
      panelpairQty: 1,
      panelpairQtySheer: "PAIR",
      panelpairQtyName: "",
      overlapValue: 0,
      overlapSheer: "0",
      finishedLength: "",
      FLZ:0,
      leftReturnValue: 3.5,
      rightReturnValue: 3.5,
      trimmingType: "No Trim",
      trimmingPattern:"",
      trimmingPatternName:"",
      trim_pattern: [],
      trimcolors: [],
      selectedTrimColor: null,
      selectedTrimColorName: "",
      showDimension: false,
      loadingName: false,
      loadingColor: false,
      finishedWidth: 0,
      dRodValue: 0,
      dFullnessValue: 3,
      calculationValue: "",
      lastCalculationState: {},
      rawCalculation: 0,
      rawDiscount:0,
      rawDiscountedAmount: 0,
      basePrice:0,
      interliningSurcharge:0,
      trimSurcharge:0,
      trimCost:0,
      canSave: false,
      line: "",
      customernotes:"",
      cartOrderMsg: "",
      grommetByColor: { colors: [], sizes: {}, sizesIds: {} },
      selectedGrommetColor: null,
      selectedGrommetSize: null,
      cartform: new Form({
        itemid: "",
        inventcolorid: "",
        pc_type: "CDI",
        unitid: "",
        order_type: "CDI",
        quantity: 1,
        discountedprice:0,
        notes: "",
        user_id: "",
        cdi_id: "",
      }),
      staticPocketOptions: null,
      staticHeaderOptions: null,
      printquotetype : "wholesale",
      pqmarkupnum:0,
    };
  },
  watch: {
    liningselect(val) {
      if (val != 'RDSSW' && val != 'RDSSI') {
        this.interliningselect = 'No';
      }
    }
  },
  methods: {
    togglepromo() {
      $(".leftpromo").toggle();
      $(".ordershow").toggleClass("minusshow");
    },
    toggleColors(e) {
      if (
        e.target.localName !== "input" &&
        e.target.className.indexOf("vs_") === -1
      ) {
        this.colorCollapsed = this.fabriccolors.length > 0 ? !this.colorCollapsed : false;
      }
    },
    setCurrentStep(step) {
      switch (step) {
        case 1:
          if (this.selectedFabricType === "Sheer") {
            this.showDimension = true;
            this.calculateFW();
          } else {
            this.showDimension = false;
          }
          this.resetName();
          this.resetColor();
          break;
        case 2:
          this.resetColor();
          break;
        case 3:
          this.colorCollapsed = true;
          break;
        case 4:
          // this.colorCollapsed = false;
          this.$root.$emit("bv::toggle::collapse", "top-style");
          break;
        default:
          break;
      }
      this.currentStep = step;
      console.log(step, "step");
    },
    reset() {
      this.qty =  1;
      this.fabrictype_value = null;
      this.interliningselect = "No";
      this.liningselect = "RDSSW";
      this.selectedFabricType = null;
      this.selectedFabricTypeName = "";
      this.selectedFabricName = "";
      this.selectedFabricNameValue = "";
      this.selectedFabricColor = null;
      this.selectedFabricColorName = "";
      this.selectedFabricColorImg = "";
      this.selectedQuantity = null;
      this.selectedStyle = null;
      this.selectedStyleName = "";
      this.styleOptionVisiblity = {
        grommet: false,
        pin: false,
        pocket: false,
        header: false,
        beadedWeight: false,
        LBeadedWeight: false,
        bottomHeader: false,
        bottomPocket: false,
      };
      this.styleOptionValues = {
        grommet: null,
        pin: null,
        pocket: null,
        header: null,
        beadedWeight: "0",
        LBeadedWeight: null,
        bottomHeader: null,
        bottomPocket: null,
      };
      this.styleOptionNames = {
        grommet: "",
        pin: "",
        pocket: "",
        header: "",
        beadedWeight: "No",
        LBeadedWeight: "",
        bottomHeader: "",
        bottomPocket: "",
      };
      this.styleSelectedDone = false;
      this.panelpairQty = 1;
      this.panelpairQtySheer = "PAIR";
      this.panelpairQtyName = "";
      this.overlapValue = 0;
      this.overlapSheer = "0";
      this.finishedLength = "";
      this.leftReturnValue = 3.5;
      this.rightReturnValue = 3.5;
      this.trimmingType = "No Trim";
      this.trimmingPattern ="";
      this.trimmingPatternName ="";
      this.selectedTrimColor = null;
      this.selectedTrimColorName = "";
      this.showDimension =  false;
      this.loadingName =  false;
      this.loadingColor =  false;
      this.finishedWidth =  0;
      this.dRodValue =  0;
      this.dFullnessValue =  3;
      this.calculationValue =  "";
      this.lastCalculationState =  {};
      this.rawCalculation =  0;
      this.rawDiscount = 0;
      this.rawDiscountedAmount =  0;
      this.basePrice = 0;
      this.interliningSurcharge = 0;
      this.trimSurcharge = 0;
      this.trimCost = 0;
      this.canSave =  false;
      this.line =  "";
      this.customernotes = "";
      this.cartOrderMsg =  "";
      this.selectedGrommetColor = null;
      this.selectedGrommetSize = null;
      this.cartform = new Form({
        itemid: "",
        inventcolorid: "",
        pc_type: "CDI",
        unitid: "",
        order_type: "CDI",
        quantity: 1,
        discountedprice:0,
        notes: "",
        user_id: "",
        cdi_id: "",
      }),
      this.staticPocketOptions = null;
      this.staticHeaderOptions = null;
      $('.collapse.show').collapse('hide');
      $('html, body').animate({scrollTop: 0 },100);
      this.setCurrentStep(1);
    },
    resetColor() {
      this.selectedFabricColor = "";
      this.selectedFabricColorName = "";
      this.selectedFabricColorImg = "";
      this.fabriccolors = [];
      // this.colorCollapsed = false;
    },
    resetName() {
      this.selectedFabricName = "";
      this.selectedFabricNameValue = "";
      this.fabricname = [];
    },
    loadTypes(cb) {
      this.setCurrentStep(0);
      this.$store
        .dispatch("loadPromoTypes")
        .then((types) => {
          this.fabrictype = types.filter(e => e.id != 'Sheer').map((d) => ({ value: d.id, text: d.name }));
          this.setCurrentStep(1);
          if (cb) {
            cb();
          }
        })
        .catch((e) => {
          this.loadTypes();
          console.log(e, "err");
        });
    },
    loadNames(selectedOption, cb) {
      this.finishedLength = "";
      this.dFullnessValue =  3;
      this.selectedFabricType = selectedOption.value;
      this.selectedFabricTypeName = selectedOption.text;
      this.setCurrentStep(1);
      this.loadStyles(this.selectedFabricType);
      this.loadingName = true;
      this.$store
        .dispatch("loadPromoNames", selectedOption.value)
        .then((names) => {
          this.fabricname = names.map((d) => ({ value: d.id, text: d.name }));
          console.log(this.fabricname, "names");
          this.loadingName = false;
          this.setCurrentStep(2);
          if (cb) {
            cb();
          }
        })
        .catch((e) => {
          this.loadNames(selectedOption);
          console.log(e, "err");
        });
    },
    loadColors(selectedOption, cb) {
      this.selectedFabricNameValue = selectedOption.text;
      // this.selectedFabricName = selectedOption.value;
      this.setCurrentStep(2);
      this.loadingColor = true;
      this.liningselect = "RDSSW";
      console.log(selectedOption.value);
      this.$store
        .dispatch("loadPromoColors", selectedOption.value)
        .then((names) => {
          this.fabriccolors = names;
          console.log(this.fabriccolors, "colors");
          this.loadingColor = false;
          if (this.selectedFabricType === "Sheer") {
            this.liningselect = "Unlined";
            this.dRodValue = 12.0;
          }
          if (this.selectedFabricType == 'LightControlled') {
            this.liningselect = "N1";
          }
          this.setCurrentStep(3);
          if (cb) {
            cb();
          }
        })
        .catch((e) => {
          console.log(e, "err");
          this.loadColors(selectedOption);
        });
    },
    selectColor(color) {
      this.selectedFabricColor = color.INVENTCOLORID;
      this.selectedFabricColorName = color.COLORNAME;
      this.selectedFabricColorImg = color.IMAGE;
      if (this.$route.params.id) {
        this.setCurrentStep(5);
      }else{
        this.setCurrentStep(4);
      }
      console.log(color, "color selected");
    },
    selectTrimColor(color){
      this.selectedTrimColor = color.INVENTCOLORID;
      this.selectedTrimColorName = color.COLORNAME;
    },
    loadQuantity(programId, value) {
      console.log(programId, "programId");
      this.$store
        .dispatch("loadPromoQuantity", { programId, value })
        .then((quantities) => {
          console.log(quantities, "quantities");
          this.quantities = quantities;
          this.onPanelPairSelect(this.panelpairQty);
        })
        .catch((e) => {
          this.loadQuantity(programId, value);
          console.log(e, "err");
        });
    },
    loadStyles(programId) {
      console.log(programId, "programId styles");
      this.$store
        .dispatch("loadPromoStyles", programId)
        .then((styles) => {
          console.log(styles, "styles");
          this.styles = styles;
          // if (this.styles.length) {
            // this.selectedStyle = this.styles[0].id;
            // this.selectedStyleName = this.styles[0].name;
            // this.onStyleSelect(this.selectedStyle);
          // }
        })
        .catch((e) => {
          this.loadStyles(programId);
          console.log(e, "err");
        });
    },
    onPanelPairSelect(value) {
      if (this.selectedFabricType != "Sheer") {
        this.quantities.forEach((q) => {
          // console.log(q, value, q.Widths === value);
          if (parseFloat(q.Widths) === parseFloat(value)) {
            this.panelpairQtyName = q.Description;
            if (parseInt(value) === 1 || parseInt(value) === 2) {
              this.dRodValue = (q.Inches - this.leftReturnValue) - this.rightReturnValue;
            }else{
              this.dRodValue = ((q.Inches - this.overlapValue) - this.leftReturnValue) - this.rightReturnValue;
            }
          }
        });
      }
      if (parseInt(value) === 1 || parseInt(value) === 2) {
        this.disableOverlapInput = true;
        this.overlapValue = 0;
      } else {
        this.disableOverlapInput = false;
      }
      console.log(value, "e");
    },
    onStyleSelect(value) {
      this.styleSelectedDone = true;
      this.setCurrentStep(5);
      Object.keys(this.styleOptionVisiblity).forEach((key) => {
        this.styleOptionVisiblity[key] = false;
      });
      this.styles.forEach((style) => {
        if (style.id === value) {
          this.selectedStyleName = style.name;
        }
      });
      switch (value) {
        case "GR":
          this.styleOptionVisiblity.grommet = true;
          this.styleOptionValues.pin = "0";
          break;
        case "SR":
          this.styleOptionVisiblity.header = true;
          this.styleOptionVisiblity.pocket = true;
          if (this.selectedFabricType === "Sheer") {
            this.styleOptionVisiblity.bottomHeader = true;
            this.styleOptionVisiblity.bottomPocket = true;
            this.styleOptionVisiblity.beadedWeight = true;
          }
          break;
        case "RP":
          this.styleOptionVisiblity.header = true;
          this.styleOptionVisiblity.pocket = true;
          this.styleOptionValues.pin = "0";
          if (this.selectedFabricType === "Sheer") {
            this.styleOptionVisiblity.bottomHeader = true;
            this.styleOptionVisiblity.bottomPocket = true;
            this.styleOptionVisiblity.beadedWeight = true;
          }
          break;
        case "PL3":
          this.styleOptionVisiblity.pin = true;
          if (this.selectedFabricType === "Sheer") {
            this.styleOptionVisiblity.LBeadedWeight = true;
            this.styleOptionVisiblity.beadedWeight = true;
            this.styleOptionVisiblity.bottomHeader = true;
            this.styleOptionVisiblity.bottomPocket = true;
          }

          break;
        default:
          this.styleOptionVisiblity.pin = true;
          break;
      }
      this.remapNamesToStyle();
      this.loadQuantity(this.selectedFabricType, value);
      console.log(this.styleOptionVisiblity, value, "styleOptionVisiblity");

      if(this.selectedFabricType == "Sheer" && this.selectedStyleName == "Pleated Three Prong"){
        this.styleOptionVisiblity.bottomHeader = false;
        this.styleOptionVisiblity.bottomPocket = false;
      }else if(this.selectedFabricType == "Sheer" && this.selectedStyleName == "Three Prong Tacked at Top"){
        this.styleOptionVisiblity.bottomHeader = false;
        this.styleOptionVisiblity.bottomPocket = false;
        this.styleOptionVisiblity.LBeadedWeight = true;
        this.styleOptionVisiblity.beadedWeight = true;
      } else if(this.selectedFabricType == "Sheer" && this.selectedStyleName == "Shirred"){
        this.styleOptionValues.bottomHeader =  "0";
        this.styleOptionValues.bottomPocket = "0.00";
      }

      if(this.selectedFabricType == "Sheer" && this.selectedStyleName == "Shirred"){
        this.staticPocketOptions = this.staticOptions.pocket;
        this.staticHeaderOptions = this.staticOptions.header;
        this.staticOptions.pocket = this.staticOptions.pocket.filter(function(obj){
          return obj.Value == "1.50";
        });
        this.staticOptions.header = this.staticOptions.header.filter(function(obj){
          return obj.Value != "1.50";
        });

        this.styleOptionValues.pocket = "1.50";
        this.styleOptionValues.header = "0.00";
      } else{
        if(this.staticPocketOptions != null){
          this.staticOptions.pocket = this.staticPocketOptions;
        }

        if(this.staticHeaderOptions != null){
          this.staticOptions.header = this.staticHeaderOptions;
        }
      }
    },
    loadStaticOptions(cb) {
      this.$store
        .dispatch("loadPromoStaticOptions")
        .then((staticOptions) => {
          this.staticOptions = {
            ...staticOptions,
            bottomHeader: staticOptions.header
              .filter((d) => d.Value !== "1.50")
              .map((d) => ({ ...d, Value: d.Value === "0.00" ? "0" : d.Value })),
          };
          this.staticOptions.grommet = this.staticOptions.grommet.map((d) => ({
            ...d,
            image: d.image
              ? "/shop/attachments/promo/" + d.image
              : "/shop/images/rm-sateen-white.jpg",
          }));
          let grommetByColor = { colors: [], sizes: {}, sizesIds: {} };
          this.staticOptions.grommet.forEach((d) => {
            if (grommetByColor.colors.includes(d.Color)) {
              grommetByColor.sizes[d.Color].push(d);
              grommetByColor.sizesIds[d.Color].push(d.Size);
            } else {
              grommetByColor.colors.push(d.Color);
              grommetByColor.sizes[d.Color] = [d];
              grommetByColor.sizesIds[d.Color] = [d.Size];
            }
          });

          this.grommetByColor = grommetByColor;

          Object.keys(this.styleOptionValues).forEach((key) => {
            if (key in this.staticOptions) {
              if (this.staticOptions[key].length) {
                switch (key) {
                  case "grommet":
                    this.styleOptionValues[key] = this.staticOptions[
                      key
                    ][0].SizeColor;
                    this.selectedGrommetColor = 0;
                    this.selectedGrommetSize =
                      grommetByColor.sizesIds[grommetByColor.colors[0]][0];
                    break;
                  case "pin":
                    this.styleOptionValues[key] = this.staticOptions[
                      key
                    ][0].PinSetSize;
                    break;

                  default:
                    this.styleOptionValues[key] = this.staticOptions[
                      key
                    ][0].Value;
                    break;
                }
              }
            }
          });
          if (cb) {
            cb();
          }
          console.log(this.staticOptions, "staticOptions");
        })
        .catch((e) => {
          this.loadStaticOptions();
          console.log(e, "err");
        });
    },
    remapNamesToStyle() {
      Object.keys(this.styleOptionValues).forEach((key) => {
        if (key in this.staticOptions) {
          if (this.staticOptions[key].length) {
            switch (key) {
              case "grommet":
                this.styleOptionNames.grommet = this.styleOptionValues.grommet;
                // this.styleOptionNames[key] = this.staticOptions[key].filter(
                //   (d) => this.styleOptionValues[key] === d.SizeColor
                // )[0].SizeColor;
                break;
              case "pin":
                var optionsfilter = this.staticOptions[key].filter(
                  (d) => this.styleOptionValues[key] === d.PinSetSize
                );
                if(optionsfilter.length > 0){
                  this.styleOptionNames[key] = optionsfilter[0].PinSetDiscFull;
                }
                break;

              default:
                if(this.styleOptionValues[key]){
                  this.styleOptionNames[key] = this.staticOptions[key].filter(
                    (d) => this.styleOptionValues[key] === d.Value
                  )[0].Description;
                }
                break;
            }
          }
        }
      });
      if (
        (this.styleOptionValues.beadedWeight === "0" ||
          this.styleOptionValues.beadedWeight === 0) &&
        this.selectedFabricType == "Sheer"
      ) {
        this.styleOptionVisiblity.bottomHeader = true;
        this.styleOptionVisiblity.bottomPocket = true;
        this.styleOptionNames.beadedWeight = "No";
      } else {
        this.styleOptionVisiblity.bottomHeader = false;
        this.styleOptionNames.beadedWeight = "Yes";
        this.styleOptionVisiblity.bottomPocket = false;
      }
      console.log(this.styleOptionNames, "styleOptionNames");
    },
    onFinishedLengthChange() {      
      if (parseInt(this.finishedLength) >= 120) {
        this.finishedLength = 120;
      }
      this.FLZ = Math.ceil(this.finishedLength % 0.125);
      if(this.FLZ == 0){
        this.canSave = true;
      }else{
        this.canSave = false;
      }     
    },
    init() {
      this.loadTypes();
      this.loadStaticOptions();
      this.loadTrimNames();
    },
    calculateFW() {
      if(this.selectedFabricType == "Sheer" && this.dRodValue > 169){
        this.dRodValue = 169;
      }
      if (this.panelpairQtySheer === "PANEL") {
        this.finishedWidth = parseFloat(this.dRodValue) + (parseFloat(this.leftReturnValue) + parseFloat(this.rightReturnValue));
      } else {
        this.finishedWidth = parseFloat(this.dRodValue) + (parseFloat(this.leftReturnValue) + parseFloat(this.rightReturnValue) + parseFloat(this.overlapSheer));
      }
      let value = this.panelpairQty;
      if(this.selectedFabricType != "Sheer"){
        this.quantities.forEach((q) => {
          if (parseFloat(q.Widths) === parseFloat(value)) {
            this.panelpairQtyName = q.Description;
            if (parseInt(value) === 1 || parseInt(value) === 2) {
              this.dRodValue = (q.Inches - this.leftReturnValue) - this.rightReturnValue;
            }else{
              this.dRodValue = ((q.Inches - this.overlapValue) - this.leftReturnValue) - this.rightReturnValue;
            }
          }
        });
      }
      console.log(this.finishedWidth, "calculateFW");
    },
    doCalculation() {
      if ((this.currentStep >= 4) & (this.finishedLength != "")) {
        let caseId = 0;
        let lined = "L";
        let width = this.panelpairQty;
        let program = this.selectedFabricType;
        let fabric = this.selectedFabricName.value;
        let color = this.selectedFabricColor;
        let style = this.selectedStyle;
        let radLen = this.finishedLength || 0;
        let grommet = this.styleOptionValues.grommet;
        let finishedWidth = 0;
        if (isNaN(this.finishedWidth)){
          finishedWidth = 0;
        } else{
          finishedWidth = this.finishedWidth;
        }
        let panelPair = this.panelpairQtySheer;
        let beadedWeight = this.styleOptionValues.beadedWeight;
        let bottomHeader = false;
        let interlining = 'No';
        let trimming_type = this.trimmingType;
        let trimming_pattern = this.trimmingPattern;
        let trimming_color = this.selectedTrimColorName;
        if(this.liningselect == "N1"){
          lined = "U";
        }
        if(this.liningselect == "RDLTI" || this.liningselect == "RDLTW"){
          interlining = this.liningselect;
        } else {
          interlining = this.interliningselect;
        }
        if(!['RDLTW', 'RDLTI'].includes(this.liningselect) || !['Pleated Three Prong', 'Pleated Two Prong','Three Prong Tacked at Top','Two Prong Tacked at Top'].includes(this.selectedStyleName)){
          this.blackoutguard = false;
          this.blackoutguardCost = 0;
        }
        let blackoutguard = this.blackoutguard;
        if (this.selectedFabricType != "Sheer") {
          if (this.panelpairQtyName.includes("Panel")) {
            this.panelpairQtySheer = "PANEL";
          } else {
            this.panelpairQtySheer = "PAIR";
          }
        }
        if (this.styleOptionVisiblity.bottomHeader) {
          if (this.styleOptionValues.bottomHeader > "0.2") {
            bottomHeader = true;
          }else{
            bottomHeader = false;
          }
        }else{
          bottomHeader = false;
        }
        if (program === "CustomDrape") {
          caseId = 1;
        } else if (program === "Sheer") {
          caseId = 2;
          width = this.panelpairQtySheer;
        }
        let finalData = {};
        switch (caseId) {
          case 0:
            finalData = {
              case: caseId,
              lined,
              width,
              program,
              fabric,
              color,
              style,
              radLen,
              interlining,
              trimming_type,
              trimming_pattern,
              trimming_color,
              panelPair,
              blackoutguard
            };
            break;
          case 1:
            finalData = {
              case: caseId,
              lined,
              width,
              program,
              fabric,
              color,
              style,
              radLen,
              interlining,
              grommet,
            };
            break;
          default:
            finalData = {
              case: caseId,
              fabric,
              panelPair,
              finishedWidth,
              beadedWeight,
              bottomHeader,
            };
            break;
        }
        if (finishedWidth === 0 && caseId === 2) {
          return;
        }
        if (Object.keys(this.lastCalculationState).length) {
          let hasChanged = false;
          Object.keys(this.lastCalculationState).forEach((key) => {
            if (!hasChanged)
              hasChanged = this.lastCalculationState[key] != finalData[key];
          });
          if (!hasChanged) {
            console.log("nothing changed");
            return;
          }
        }
        this.canSave = false;
        this.calculationValue = "Calculating...";
        this.lastCalculationState = finalData;
        this.$store
          .dispatch("loadPromoCalculation", finalData)
          .then((calculation) => {
            if (calculation.status) {
              if (calculation.value.length) {
                let val = calculation.value[0].Total || calculation.value[0].Price;
                if (parseFloat(val) > 0) {
                  this.calculationValue = `$${parseFloat(val).toFixed(2)}`;
                  this.rawCalculation = parseFloat(val);
                  this.rawDiscount = parseFloat(calculation.Discount);
                  let discounted = (parseFloat(val) * this.rawDiscount) / 100;
                  this.rawDiscountedAmount = parseFloat(val) - parseFloat(discounted);
                  this.basePrice = parseFloat((calculation.value[0].basePrice) * 2).toFixed(2);
                  this.interliningSurcharge = parseFloat((calculation.value[0].interliningSurcharge) * 2).toFixed(2);
                  this.blackoutguardCost = parseFloat((calculation.value[0].blackoutGuardSurcharge) * 2).toFixed(2);
                  this.trimSurcharge = parseFloat((calculation.value[0].trimSurcharge) * 2).toFixed(2);
                  this.trimCost = parseFloat((calculation.value[0].trimCost) * 2).toFixed(2);
                  this.FLZ = Math.ceil(this.finishedLength % 0.125);
                  if(this.FLZ == 0){
                    this.canSave = true;
                  }else{
                    this.canSave = false;
                  }
                }
              }
            }
            console.log(calculation, "done calculation");
          })
          .catch((e) => {
            console.log(e);
            this.doCalculation();
          });
        console.log(finalData, "doing calculation1");
      }
    },
    saveData(updateProject = false) {
      return new Promise((resolve, reject) => {
        if (!this.line.length) {
          this.$notify({
            text: "Please enter project name",
            type: "error",
          });
          reject("INVALID_LINE_NOTE");
          return;
        }
        if (!this.finishedLength) {
          this.$notify({
            text: "Please enter Finished Length",
            type: "error",
          });
          reject("INVALID_FINISHED_LENGTH");
          return;
        }
        if (this.selectedFabricType != "Sheer") {
          this.dFullnessValue = 2.5;
          this.bottomPocket = 0.2;
          if (this.panelpairQtyName.includes("Panel")) {
            this.panelpairQtySheer = "PANEL";
          } else {
            this.panelpairQtySheer = "PAIR";
          }
        }
        var bottomHeader = this.styleOptionValues.bottomHeader;
        var bottomPocket = this.styleOptionValues.bottomPocket;
        if(this.selectedFabricType == "Sheer" && this.selectedStyleName == "Pleated Three Prong"){
          bottomHeader = null;
          bottomPocket = null;
        }
        if(this.selectedFabricType == "Sheer" && this.selectedStyleName == "Three Prong Tacked at Top"){
          bottomHeader = null;
          bottomPocket = null;
        }
        let olapval = this.overlapValue;
        if(this.selectedFabricType == "Sheer"){
          olapval = this.overlapSheer;
        }
        // if(this.selectedStyle == "RP" || this.selectedStyle == "GR"){
        //   this.dRodValue = "1";
        // }
        this.$store
          .dispatch(updateProject ? "loadUpdateData" : "loadAddData", {
            name: this.line,
            programId: this.selectedFabricType,
            fabricId: this.selectedFabricName.value,
            colorId: this.selectedFabricColor,
            liningType: this.liningselect,
            blackoutguard: this.blackoutguard,
            interlining: this.interliningselect,
            style: this.selectedStyle,
            pin: this.styleOptionValues.pin,
            header: this.styleOptionValues.header,
            pocket: this.styleOptionValues.pocket,
            bottomHeader: bottomHeader,
            bottomPocket: bottomPocket,
            beadedWeight: this.styleOptionValues.beadedWeight,
            LBeadedWeight: this.styleOptionValues.LBeadedWeight,
            panelpairqty: this.panelpairQty,
            leftReturn: this.leftReturnValue,
            rightReturn: this.rightReturnValue,
            finishedLength: this.finishedLength,
            overlap: olapval,
            rodInches: this.dRodValue,
            panelpairsheer: this.panelpairQtySheer,
            fullness: this.dFullnessValue,
            calculation: this.rawCalculation,
            discount: this.rawDiscount,
            qty: this.qty,
            grommet: this.styleOptionValues.grommet,
            product_name: this.panelpairQtyName,
            trimming_type: this.trimmingType,
            trimming_pattern: this.trimmingPattern,
            trimming_color: this.selectedTrimColorName,
            customernotes:this.customernotes,
            otherdata: {
              FabricType: this.selectedFabricTypeName,
              FabricName: this.selectedFabricNameValue + ' ' +this.selectedFabricColorName,
              Lining: this.liningselectMap[this.liningselect],
              BlackoutGuard: this.blackoutguard,
              Interlining: this.interliningselectMap[this.interliningselect],
              Style: this.selectedStyleName,
              ColorSize: this.styleOptionNames.grommet,
              PinSetting: this.styleOptionNames.pin,
              PocketSize: this.styleOptionNames.pocket,
              HeaderSize: this.styleOptionNames.header,
              PanelsPairsQty: this.panelpairQtyName,
              TrimmingType: this.trimmingType,
              TrimmingPattern: this.trimmingPatternName,
              TrimmingColor: this.selectedTrimColorName,
              LeftReturn: this.leftReturnValue,
              RightReturn: this.rightReturnValue,
              Overlap: this.overlapValue,
              FinishedLength: this.finishedLength,
              PairPanel: this.panelpairQtySheer,
              OverlapInches: this.overlapSheer,
              Fullness: this.dFullnessValue,
              RodInches: this.dRodValue,
              BeadedWeight: this.styleOptionNames.beadedWeight,
              BottomHeading: this.styleOptionNames.bottomHeader,
              BottomRodPocket: this.styleOptionNames.bottomPocket,
              ProjectName: this.line,
              Notes: this.customernotes,
              BasePrice: this.basePrice,
              InterliningSurcharge: this.interliningSurcharge,
              TrimSurcharge: this.trimSurcharge,
              TrimCost:this.trimCost,
              BlackoutGuardSurcharge: this.blackoutguardCost,
              Total: (this.qty * this.rawCalculation),
            },
            ...(updateProject ? { id: this.$route.params.id } : {}),
          })
          .then((data) => {
            resolve(data);
            //console.log(data, "saved data");
          })
          .catch((e) => {
            //console.log(e);
            reject("FAILED_TO_SAVE");
          });
      });
    },
    onChangeQTY() {
      if (parseInt(this.qty) <= 0) {
        this.qty = parseInt(1);
      }
      console.log(this.qty);
    },
    decrement() {
      if (this.qty > 1) this.qty = parseInt(this.qty) - 1;
    },
    increment() {
      this.qty = parseInt(this.qty) + 1;
      console.log(this.qty);
    },
    addtocartpanel() {
      if (this.$route.query.hasOwnProperty('cart')) {
          this.saveData(true).then((data) => {
            this.updateCart(data).then((rsdata) => {
              this.$notify({
                text: "Panel program update successfully",
                type: "success",
              });
              this.$router.push({ name: "cart" });
            });
          })
          .catch((error) => {
            console.log(error);
          });
          return;
      }
      this.$store
        .dispatch("loadCart", this.user.accountnumber)
        .then((minicart) => {
          var submit = 1;
          if (minicart.data.ITEMS.length > 0) {
            if (!(minicart.data.ITEMS[0].PC_TYPE == "CDI" || minicart.data.ITEMS[0].PC_TYPE == "CDIQ" || minicart.data.ITEMS[0].PC_TYPE == "CDIP")) {
              if (minicart.data.ITEMS[0].PC_TYPE != this.cartform.pc_type) {
                this.cartOrderMsg = `${this.cartform.pc_type} orders cannot be placed with ${minicart.data.ITEMS[0].COLORWORKS == "1" ? 'Colorworks' : minicart.data.ITEMS[0].PC_TYPE} orders. Please finish placing your ${minicart.data.ITEMS[0].COLORWORKS == "1" ? 'Colorworks' : minicart.data.ITEMS[0].PC_TYPE} order and then place your ${this.cartform.pc_type} order separately.`
                submit = 0;
                this.$refs["cartmodal"].show();
                return false;
              }
            }
          }
          if (submit == 1) {
            this.saveData().then((data) => {
              this.cartform.itemid = data.fabricId;
              this.cartform.inventcolorid = data.colorId;
              this.cartform.user_id = this.user.accountnumber;
              this.cartform.cdi_id = data.id;
              this.cartform.quantity = data.qty;
              this.cartform.discountedprice = this.rawDiscountedAmount;
              this.$store
                .dispatch("AddtoCart", {
                  form: this.cartform,
                })
                .then((rsdata) => {
                  if (rsdata.data.success == false) {
                    this.cartOrderMsg = rsdata.data.message;
                    this.$refs["cartmodal"].show();
                  } else {
                    this.$notify({
                      text: "Product added to cart",
                      type: "success",
                    });
                    this.reset();
                    this.isLoading = true;
                    this.$store
                      .dispatch("loadCart", this.user.accountnumber)
                      .finally(() => {
                        this.isLoading = false;
                      });
                  }
                })
                .catch((error) => {
                  if (this.cartform.hasErrors()) {
                    this.$notify({
                      text:
                        "There is a validation error. Please correct the fields outlined in red and try again.",
                      type: "error",
                    });
                  } else {
                    this.$notify({
                      text: "Something went wrong!",
                      type: "error",
                    });
                  }
                });
            });
          }
        });
    },
    updateCart(data){
      return new Promise((resolve, reject) => {
        this.cartform.itemid = data.fabricId;
        this.cartform.inventcolorid = data.colorId;
        this.cartform.user_id = this.user.accountnumber;
        this.cartform.cdi_id = data.id;
        this.cartform.quantity = data.qty;
        this.cartform.discountedprice = this.rawDiscountedAmount;
        this.$store.dispatch("updateCDICart", {
          form: this.cartform,
        }).then((rsdata) => {
          resolve(rsdata);
        }).catch((e) => {
          //console.log(e);
          reject("CART_FAILED_TO_UPDATE");
        });
      });
    },
    saveToProject() {
      if (this.$route.params.id) {
        this.saveData(true)
          .then((data) => {
            this.$notify({
              text: "Panel Program update successfully",
              type: "success",
            });
          })
          .catch((error) => {
            console.log(error);
          });
        return;
      }
      this.saveData()
        .then((data) => {
          this.$refs.project.show(data.id,"0");
        })
        .catch((error) => {
          console.log(error);
        });
    },
    onGrommetColorChange(value) {
      this.selectedGrommetSize = this.grommetByColor.sizesIds[this.selectedGrommetColor][0];
      this.styleOptionValues.grommet = this.selectedGrommetSize + " " + value;
      this.remapNamesToStyle();
    },
    onGrommetSizeChange(value) {
      this.styleOptionValues.grommet = value + " " + this.selectedGrommetColor;
      console.log(value, this.selectedGrommetSize);
      this.remapNamesToStyle();
    },
    onSheerFinishedLengthChange(){
      if (parseInt(this.finishedLength) <= 0) {
        this.finishedLength = 1;
      }

      if (parseFloat(this.finishedLength) >= 99) {
        this.finishedLength = 99;
      }

      if (this.finishedLength.toString().includes('.')) {
        this.finishedLength = this.finishedLength.split('.')[0] + '.' + this.finishedLength.split('.')[1].slice(0, 3)
      }
      this.FLZ = Math.ceil(this.finishedLength % 0.125);
      if(this.FLZ == 0){
        this.canSave = true;
      }else{
        this.canSave = false;
      }  
    },
    loadData(id) {
      this.loadTrimNames();
      this.$store
        .dispatch("loadGetData", id)
        .then((data) => {
          this.line = data.name;
          this.customernotes = data.customernotes;
          // this.selectedFabricType = data.programId
          // this.selectedFabricName = {value:data.fabricId}
          // this.selectedFabricColor = data.colorId
          this.liningselect = data.liningType;
          // this.interliningselect = data.interlining;
          this.interliningselect = "No";
          this.selectedStyle = data.style;
          this.panelpairQty = data.panelpairqty;
          this.leftReturnValue = data.leftReturn;
          this.rightReturnValue = data.rightReturn;
          if (data.programId == "Sheer") {
            this.overlapSheer = data.overlap;
          } else {
            this.overlapValue = data.overlap;
          }
          this.panelpairQtySheer = data.panelpairsheer;
          this.dFullnessValue = data.fullness;
          this.rawCalculation = data.calculation;
          this.qty = data.qty;
          this.styleOptionValues.grommet = data.grommet;
          this.loadTypes(() => {
            this.fabrictype.forEach((d) => {
              if (d.value == data.programId) {
                this.fabrictype_value = { value: data.programId, text: d.text };
              }
            });
            this.selectedFabricType = data.programId;
            this.loadStaticOptions(() => {
              this.loadNames(
                {
                  value: this.fabrictype_value.value,
                  text: this.fabrictype_value.text,
                },
                () => {
                  this.fabricname.forEach((d) => {
                    if (d.value == data.fabricId) {
                      this.selectedFabricName = {
                        value: data.fabricId,
                        text: d.text,
                      };
                      this.loadColors(
                        { value: data.fabricId, text: d.text },
                        () => {
                          this.dRodValue = data.rodInches;
                          this.fabriccolors.forEach((d) => {
                            if (d.INVENTCOLORID == data.colorId) {
                              this.selectColor(d);
                              this.onStyleSelect(data.style);
                              this.styleOptionNames.grommet = data.grommet;
                              if(data.style == 'GR'){
                                this.selectedGrommetColor = this.staticOptions["grommet"].filter(
                                  (d) => data.grommet == d.SizeColor
                                )[0].Color;
                                this.selectedGrommetSize = this.staticOptions["grommet"].filter(
                                  (d) => data.grommet == d.SizeColor
                                )[0].Size;
                              }
                              if(data.pin){
                                this.styleOptionValues.pin = data.pin;
                                this.styleOptionNames.pin;
                                var optionsfilter = this.staticOptions["pin"].filter(
                                  (d) => this.styleOptionValues["pin"] === d.PinSetSize
                                );
                                if(optionsfilter.length > 0){
                                  this.styleOptionNames["pin"] = optionsfilter[0].PinSetDiscFull;
                                }
                              }
                            }
                            this.liningselect = data.liningType;
                            this.interliningselect = data.interlining;
                            this.blackoutguard = Boolean(Number(data.blackoutguard));
                          });
                          this.styleOptionValues.header = data.header;
                          this.styleOptionValues.pocket = data.pocket;
                          this.styleOptionValues.bottomHeader = data.bottomHeader;
                          this.styleOptionValues.bottomPocket = data.bottomPocket;
                          this.styleOptionValues.beadedWeight = data.beadedWeight;
                          this.styleOptionValues.LBeadedWeight = data.LBeadedWeight;
                          this.finishedLength = Number(data.finishedLength);
                        }
                      );
                    }
                  });
                }
              );
            });
          });
          if (data.programId != "Sheer") {
            this.trimmingType = data.trimming_type;
            this.trimmingPattern = data.trimming_pattern;
            this.loadTrimColors();
            this.selectedTrimColorName = data.trimming_color;
            if(data.trimming_type != "No Trim"){
              let tp = this.trimmingPattern;
              let tpname = this.trim_pattern.find(e => e.ITEMID == tp);
              this.trimmingPatternName = tpname.ITEMNAME;
            }
          }
          // this.currentStep = 5;
          console.log(data, "data get data");
        })
        .catch((e) => {
          this.loadData(id);
          console.log(e);
        });
    },
    loadTrimNames() {
      this.loadingColor = true;
      this.$store.dispatch("loadPromoTrimNames").then((names) => {
          this.trim_pattern = names;
          this.loadingColor = false;
      }).catch((e) => {
        console.log(e, "err");
      });
    },
    loadTrimColors() {
      this.loadingColor = true;
      this.$store.dispatch("loadPromoTrimColors", this.trimmingPattern).then((names) => {
          this.trimcolors = names;
          let tp = this.trimmingPattern;
          let tpname = this.trim_pattern.find(e => e.ITEMID == tp);
          this.trimmingPatternName = tpname.ITEMNAME;
          this.loadingColor = false;
      }).catch((e) => {
        console.log(e, "err");
      });
    },
    printQuote(){
      this.$refs["printquotemodal"].show();
    },
    printQuoteGen(){
      this.saveData().then((data) => {
          const url = '/shop/promo-print?type='+this.printquotetype+'_'+this.pqmarkupnum+'&id='+data.id;
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('target', '_blank');
          document.body.appendChild(link);
          link.click();
      }).catch((error) => {
        console.log(error);
      });
    },
  },
};
</script>

<style>
.validmsg{font-size: 12px;color: #f00;}
.promopage {
  display: flex;
  width: 100%;
  flex-wrap: nowrap;
  justify-content: space-between;
  margin-bottom: 90px;
  align-items: baseline;
}
.promopage .leftpromo {
  max-width: 400px;
  width: 21%;
  padding: 20px;
  box-sizing: border-box;
  background: #ececec;
  position: sticky;
  top: 165px;
  /*max-height: 750px;
  min-height: 750px;*/
  overflow-y: auto;
  width: 100%;
  height: auto;
}
.headwrap.positionfix + .container .promopage .leftpromo {
  top: 125px;
}
.promopage .leftpromo .promodata {
  margin-top: 20px;
}
.page--promo .common_pop.save_project .modal-body {
  display: block;
}
.common_pop.save_project .modal-body .btn.btn-dark.view-proj {
  padding-left: 15px;
  padding-right: 15px;
  margin: 0 auto;
  display: block;
  max-width: 230px;
}
.promopage .leftpromo h1,
.promopage .leftpromo .promodata .commondata-div h3 {
  text-align: left;
}
.promopage .leftpromo .promodata .commondata-div {
  margin-bottom: 20px;
}
.promopage .leftpromo .promodata .commondata-div.firstset {
  display: flex;
  align-items: flex-start;
}
.promopage .leftpromo .promodata .commondata-div.secondset {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
}
.promopage .leftpromo .promodata .commondata-div.firstset h3,
.promopage .leftpromo .promodata .commondata-div.secondset h3 {
  margin-top: 5px;
}
.promopage .leftpromo .promodata .commondata-div.firstset h3,
.promopage .leftpromo .promodata .commondata-div.secondset h3 {
  width: 40%;
}
.promopage .leftpromo .promodata .commondata-div p {
  font-size: 16px;
  line-height: 30px;
  display: flex;
  align-items: flex-start;
}
.promopage .leftpromo .promodata .commondata-div p span {
  width: 45%;
}
.promopage
  .leftpromo
  .promodata
  .commondata-div.lastpricediv
  p
  span:first-child {
  width: 65%;
}
.promopage .leftpromo .promodata h3 {
  margin-bottom: 0;
}
.promopage .leftpromo .promodata .commondata-div img.selectedimg.img-fluid {
  width: 100%;
  max-width: 150px;
  border-radius: 4px;
}
.lastpricediv p {
  text-align: center;
}
.promopage .leftpromo .promodata .quantity-div {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
}
.promopage .ordershow {
  display: none;
}
.promopage .leftpromo .promodata .quantity-div > span {
  margin-right: 10px;
}
.promopage .leftpromo .promodata .samediv.quantity {
  width: 45%;
}
.promopage .leftpromo .promodata .samediv.quantity span {
  margin-top: 5px;
}
.promopage .leftpromo .promodata .samediv .qtydiv span {
  float: left;
  font-size: 18px;
  border: 1px solid #d2d2d2;
  margin: 0;
  height: 35px;
  line-height: 35px;
  padding: 0 14px;
  font-weight: 500;
  color: #303030;
  -webkit-border-top-left-radius: 3px;
  -webkit-border-bottom-left-radius: 3px;
  -moz-border-radius-topleft: 3px;
  -moz-border-radius-bottomleft: 3px;
  border-top-left-radius: 3px;
  border-bottom-left-radius: 3px;
  cursor: pointer;
  background: #fff;
}
.promopage .leftpromo .promodata .samediv .qtydiv span.lastspan {
  -webkit-border-top-right-radius: 3px;
  -webkit-border-bottom-right-radius: 3px;
  -moz-border-radius-topright: 3px;
  -moz-border-radius-bottomright: 3px;
  border-top-right-radius: 3px;
  border-bottom-right-radius: 3px;
  -webkit-border-top-left-radius: 0;
  -webkit-border-bottom-left-radius: 0;
  -moz-border-radius-topleft: 0;
  -moz-border-radius-bottomleft: 0;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  line-height: 40px;
}
.promopage .leftpromo .promodata .samediv .qtydiv input {
  float: left;
  max-width: 45px;
  font-size: 14px;
  height: 35px;
  text-align: center;
  border-top: 1px solid #d2d2d2;
  border-bottom: 1px solid #d2d2d2;
  border-left: 0;
  border-right: 0;
  font-weight: 500;
  color: #303030;
  padding-top: 6px;
}
.promopage .leftpromo .promodata button.btn.btn-dark {
  width: 100%;
  margin-right: 0;
  margin-top: 20px;
  margin-bottom: 20px;
}
.promopage .leftpromo .promodata button.btn.btn-outline-primary {
  width: 100%;
  margin-top: 0;
}
.promopage .leftpromo .promodata .saveproject {
  height: 15px;
  width: 11px;
  margin: -3px 8px 0 0;
}
.promopage .leftpromo .promodata .saveproject.white {
  display: none;
}
.promopage
  .leftpromo
  .promodata
  button.btn.btn-outline-primary:hover
  .saveproject {
  display: none;
}
.promopage
  .leftpromo
  .promodata
  button.btn.btn-outline-primary:hover
  .saveproject.white {
  display: inline-block;
  margin-right: 12px;
}
.promopage .rightpromo {
  width: 100%;
  margin-left: 40px;
  min-height: 615px;
  max-width: 100%;
  margin-top: 40px;
}
.promopage .rightpromo h1 {
  text-align: left;
}
.promopage .rightpromo .availabledata ul.avail_data > li {
  padding: 35px 0;
  border-bottom: 1px solid #d2d2d2;
}
.promopage .rightpromo .availabledata ul.avail_data > li > a {
  font-weight: 500;
  font-size: 16px;
  width: 100%;
  color: #303030;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.promopage .rightpromo .availabledata ul.avail_data > li > a:hover {
  text-decoration: none;
}
.promopage .rightpromo .availabledata ul.avail_data > li > a > span {
  float: left;
  margin-top: 10px;
  max-width: 188px;
  width: 100%;
}
.promopage .rightpromo .availabledata ul.avail_data > li > a:hover {
  text-decoration: none;
}
.promopage
  .rightpromo
  .availabledata
  ul.avail_data
  > li
  > a.collapsed
  img.addicon {
  height: 12px;
  width: 12px;
  display: block;
  margin-left: auto;
}
.promopage
  .rightpromo
  .availabledata
  ul.avail_data
  li
  > a.collapsed
  img.minusicon {
  width: 12px;
  display: none;
  margin-left: auto;
}
.promopage .rightpromo .availabledata ul.avail_data > li > a img.minusicon {
  display: block;
  width: 12px;
  margin-left: auto;
}
.promopage .rightpromo .availabledata ul.avail_data > li > a img.addicon {
  display: none;
}
.promopage .rightpromo .availabledata ul.avail_data > li h3 {
  text-align: left;
}
.promopage .rightpromo .availabledata ul.avail_data > li h3.regularfont {
  font-weight: normal;
}
.promopage .rightpromo .v-select {
  position: relative;
  width: 100%;
  float: left;
  max-width: 317px;
}
.promopage .rightpromo .vs__dropdown-toggle {
  height: 38px;
  padding: 0;
  border: 1px solid #d2d2d2;
  border-radius: 3px;
  background: #fff;
}
.promopage .rightpromo .vs__dropdown-menu {
  border: 1px solid #d2d2d2;
  box-shadow: none;
  width: 100%;
  font-weight: normal;
}
.promopage .rightpromo .v-select .vs__actions::after {
  border: none;
  content: "";
  background: url(/shop/images/arrow.svg) no-repeat center;
  height: 10px;
  width: 10px;
  position: absolute;
  right: 12px;
  top: 14px;
  margin: 0;
}
.promopage .rightpromo .vs__actions .vs__open-indicator {
  display: none;
}
.promopage .rightpromo .v-select.vs--open .vs__actions::after {
  transform: rotate(180deg);
}
.promopage .rightpromo .vs--single .vs__selected {
  font-size: 14px;
  color: #777;
  padding: 0 7px 0 13px;
}
.promopage .rightpromo .vs--single.vs--open .vs__selected {
  position: relative;
  opacity: 1;
}
.promopage .rightpromo .vs__dropdown-option {
  font-size: 12px;
  color: #303030;
  line-height: 30px;
  font-weight: normal;
}
.promopage .rightpromo .vs__dropdown-option:hover {
  font-weight: 600;
}
.promopage .rightpromo .vs__dropdown-option--highlight {
  background: transparent;
  color: #777;
}
.promopage .rightpromo .vs__search,
.promopage .rightpromo .vs__search:focus {
  padding: 0 7px 0 13px;
  font-size: 14px;
  font-weight: normal;
  color: #303030;
}
.promopage .rightpromo .select-color {
  display: flex;
  justify-content: flex-start;
  width: 100%;
  flex-wrap: wrap;
  margin-top: 30px;
}
.promopage .rightpromo .collapse > h3 {
  margin-top: 40px;
}
.promopage .rightpromo .collapse .select-color .image-name-box {
  width: 20%;
  margin-bottom: 10px;
  padding: 7px 7px 0 7px;
  box-sizing: border-box;
  max-width: 163px;
  border: 1px solid rgba(255, 255, 255, 0);
  border-radius: 3px;
  transition: all 0.3s ease;
}
.promopage .rightpromo .collapse .select-color .image-name-box:hover {
  border: 1px solid #dddddd;
}
.promopage .rightpromo .collapse .select-color .image-name-box.selected {
  border: 1px solid #777777;
  border-radius: 3px;
}
.promopage .rightpromo .collapse .select-color .image-name-box:hover {
  text-decoration: none;
}
.promopage .rightpromo .collapse .select-color .image-name-box .image-box {
  width: 100%;
  max-width: 145px;
  border-radius: 4px;
  background: #ccc;
}
.promopage .rightpromo .collapse .select-color .image-name-box .image-box img {
  width: 100%;
  min-height: 100px;
  border-radius: 4px;
}
.promopage .rightpromo .collapse .select-color .image-name-box h4 {
  font-weight: 600;
  text-align: left;
  line-height: 36px;
}
.promopage .rightpromo .collapse.show {
  min-height: auto;
}
.promopage .rightpromo .select-radio {
  margin-top: 30px;
}
.promopage .rightpromo .md-radio .md-radio-label {
  padding-left: 0;
  left: -10px;
  top: 12px;
}
.promopage .rightpromo .md-radio-override .md-radio-label {
  padding-left: 10px;
  padding-right: 10px;
  margin-top: 10px;
  left: 0px;
  top: 0px;
  height: auto !important;
}
.promopage .rightpromo .md-radio {
  height: 215px;
  border: 1px solid #d2d2d2;
  border-radius: 5px;
  max-width: 160px;
  margin-bottom: 40px !important;
}

.promopage .rightpromo .md-radio-override {
  height: auto;
}
.promopage .rightpromo .md-radio-override .md-radio-label {
  padding-left: 10px;
  margin-bottom: 10px;
}
.promopage .rightpromo .select-radio + h3.regularfont {
  margin-top: 0;
}
.promopage .rightpromo .md-radio.md-checked {
  border: 1px solid #303030;
}
.promopage .rightpromo .md-radio p {
  font-size: 14px;
  font-weight: 500;
  line-height: normal;
  margin-top: 10px;
}
.promopage .rightpromo .md-radio .md-radio-container {
  top: -8px;
  left: -8px;
  background: #ffffff;
}

.promopage .rightpromo .md-radio-override .md-radio-container {
  top: 0px;
  left: 0px;
  margin: 15px 0px 0px 10px;
}
.promopage .rightpromo .gromet-color {
  display: flex;
  align-items: center;
}
.promopage .rightpromo .gromet-color span,.promopage .rightpromo .trim-pattern > span {
  min-width: 188px;
  margin-top: 3px;
}
.promopage .rightpromo .gromet-color span,.promopage .rightpromo .trim-pattern{
  display: flex;
  align-items: center;
}
.promopage .rightpromo .gromet-color span,.promopage .rightpromo .trim-pattern .select2{max-width: 317px;}
.promopage .rightpromo #panel-qty .md-radio {
  margin-bottom: 0 !important;
}
.promopage .rightpromo .md-radio:hover,
.promopage .rightpromo .md-radio:hover .md-radio-container {
  border: 1px solid #303030 !important;
}
.promopage .rightpromo .measurement-div {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: center;
  margin-top: 30px;
}
.promopage .rightpromo .no-bottom-border {
  border-bottom: none;
}
.promopage .rightpromo .measurement-div .length-div,
.promopage .rightpromo .measurement-div .length-div-select {
  width: 50%;
  margin-bottom: 35px;
}
.promopage .rightpromo .measurement-div .length-div span,
.promopage .rightpromo .measurement-div .length-div-select span {
  font-size: 16px;
  color: #303030;
  min-width: 175px;
  display: inline-block;
}
.promopage .rightpromo .measurement-div .length-div input {
  border: 1px solid #d2d2d2;
  height: 43px;
  border-radius: 3px;
  width: 100%;
  padding: 10px 10px 10px 20px;
  box-sizing: border-box;
  font-size: 14px !important;
  overflow: hidden;
  color: #777777;
  max-width: 270px;
}
.promopage .rightpromo .measurement-div .length-div .md-field {
  display: inline-block;
  max-width: 270px;
  margin: 0;
  padding: 0;
}
.promopage .rightpromo .measurement-div .length-div.linediv {
  width: 100%;
  margin: 0;
}
.promopage .rightpromo .measurement-div .length-div.linediv .md-field,
.promopage .rightpromo .measurement-div .length-div.linediv .md-field input {
  max-width: 100%;
}
.slide-fade-enter-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-leave-active {
  transition: all 0.1s ease;
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
.promopage .leftpromo .promodata button.btn.btn-outline-primary.printQuoteModelBtn{margin-top: 20px;}
.not-available {
  opacity: 0.4;
  cursor: not-allowed;
  pointer-events: none;
  -webkit-user-drag: none;
  -webkit-user-select: none;
}
@media only screen and (max-width: 1440px) {
  .promopage .leftpromo {
    max-width: 340px;
  }
  .promopage .rightpromo .measurement-div .length-div span,
  .promopage .rightpromo .measurement-div .length-div-select span {
    min-width: 140px;
  }
  .promopage .rightpromo .measurement-div .length-div input {
    max-width: 230px;
  }
  .promopage .rightpromo .measurement-div .length-div .md-field {
    max-width: 230px;
  }
  .promopage .rightpromo .measurement-div .length-div.linediv {
    width: 100%;
    margin: 0;
  }
  .promopage .rightpromo .measurement-div .length-div.linediv .md-field,
  .promopage .rightpromo .measurement-div .length-div.linediv .md-field input {
    max-width: 100%;
  }
}
@media only screen and (max-width: 1024px) and (min-width: 768px) {
  .promopage .leftpromo {
    max-width: 270px;
    padding: 12px;
    top: 145px;
  }
  .headwrap.positionfix + .container .promopage .leftpromo {
    top: auto;
  }
  .promopage .rightpromo {
    width: 100%;
    margin-left: 20px;
  }
  .promopage .rightpromo .v-select {
    max-width: 280px;
  }
  .promopage .rightpromo .vs--single .vs__selected,
  .promopage .rightpromo .vs__search,
  .promopage .rightpromo .vs__search:focus {
    font-size: 13px;
    padding-right: 6px;
    padding-left: 6px;
  }
  .promopage .rightpromo .availabledata ul.avail_data > li > a > span {
    max-width: 128px;
  }
  .promopage .rightpromo .collapse .select-color .image-name-box {
    width: 25%;
  }
  .promopage .leftpromo .promodata .samediv.quantity {
    width: 67%;
  }
  .promopage .rightpromo #panel-qty .md-radio {
    margin-bottom: 40px !important;
  }
  .promopage .rightpromo .measurement-div .length-div .md-field {
    max-width: 200px;
    margin-top: 10px;
  }
  .promopage .rightpromo .measurement-div .length-div span,
  .promopage .rightpromo .measurement-div .length-div-select span {
    min-width: 100%;
  }
}
@media only screen and (max-width: 767px) {
  .promopage {
    flex-wrap: wrap;
  }
  .promopage .leftpromo {
    width: 100%;
    padding: 15px;
    max-width: 100%;
    position: relative;
    top: auto;
    margin: 0 0 0 0;
    max-height: inherit;
    min-height: auto;
    display: none;
    order: 3;
  }
  .headwrap.positionfix + .container .promopage .leftpromo {
    top: auto;
  }
  .promopage .rightpromo {
    width: 100%;
    max-width: 100%;
    margin: 30px 0 0 0;
    order: 1;
  }
  .promopage .ordershow {
    display: block;
    color: #303030;
    font-size: 16px;
    float: none;
    margin: 40px 0 0 0;
    width: 100%;
    text-align: center;
    text-decoration: none;
    background: #ececec;
    padding: 15px 10px;
    border: 1px solid #303030;
    order: 2;
  }
  .promopage .ordershow:hover {
    text-decoration: none;
  }
  .promopage .ordershow .plusfil {
    width: 12px;
    margin-left: 5px;
    display: inline-block;
  }
  .promopage .ordershow .minusfil {
    width: 12px;
    margin-left: 5px;
    display: none;
  }
  .promopage .ordershow.minusshow .plusfil {
    display: none;
  }
  .promopage .ordershow.minusshow .minusfil {
    display: inline-block;
  }
  .promopage .rightpromo .v-select {
    max-width: 300px;
  }
  .promopage .rightpromo .vs--single .vs__selected,
  .promopage .rightpromo .vs__search,
  .promopage .rightpromo .vs__search:focus {
    font-size: 13px;
    padding-right: 6px;
    padding-left: 6px;
  }
  .promopage .rightpromo .availabledata ul.avail_data > li > a {
    font-size: 14px;
    flex-wrap: wrap;
  }
  .promopage .rightpromo .availabledata ul.avail_data > li > a > span {
    max-width: 100%;
    margin: 0 0 20px 0;
  }
  .promopage .rightpromo .collapse .select-color .image-name-box {
    width: 25%;
  }
  .promopage .leftpromo .promodata .samediv.quantity {
    width: 67%;
  }
  .promopage .rightpromo #panel-qty .md-radio {
    margin-bottom: 40px !important;
  }
  .promopage .rightpromo .measurement-div .length-div .md-field {
    max-width: 200px;
    margin-top: 10px;
  }
  .promopage .rightpromo .measurement-div .length-div span,
  .promopage .rightpromo .measurement-div .length-div-select span {
    min-width: 100%;
  }
  .promopage .rightpromo .select-color {
    justify-content: center;
  }
  .promopage .rightpromo .md-radio:nth-child(2n + 2) {
    margin-right: 0;
  }
  .promopage .rightpromo .measurement-div .length-div,
  .promopage .rightpromo .measurement-div .length-div-select {
    width: 100%;
    margin-bottom: 15px;
  }
  .promopage .rightpromo .collapse .select-color .image-name-box {
    width: 50%;
  }
  .promopage .rightpromo .measurement-div .length-div .md-field,
  .promopage .rightpromo .measurement-div .length-div input {
    max-width: 100%;
  }
}
</style>